<template>
  <div class="container"
    :class="{'text-center': centered}">
    <share-button/>
  </div>

</template>

<script>
import ShareButton from "../small_parts/ShareButton.vue";

export default {
  name: "FullWidthShareBtn",
  components: {ShareButton},
  props: {
    /**props**/
    centered: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
}
</script>
